module.exports = __webpack_public_path__ + "img/frame04_current.553dddd2.png";